import { s } from "../../../../utilities/common"

export const PlayIcon = () => {
  return (
    <svg
      style={{ marginLeft: s("20px") }}
      width={s("40")}
      height={s("40")}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.1204 17.8346L13.7563 7.0084C12.2433 6.12357 10 7.0084 10 9.1424V30.7947C10 32.7726 12.0868 33.9697 13.7563 32.9808L32.1204 22.1546C33.7377 21.1657 33.7377 18.8235 32.1204 17.8346Z"
        fill="#303949"
      />
    </svg>
  )
}
